module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Thomas Christensen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Thomas Christensen")]), _vm._v(" is the Avalon Foundation Professor of Music and the Humanities at the University of Chicago and editor of "), _c('I', [_vm._v("The Cambridge History of Western Music Theory")]), _vm._v("."), _c('br'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/z7SSDq/tc-custom/9780226627083.jpg?1722573305210",
      "alt": "This image is the cover for the book Stories of Tonality in the Age of François-Joseph Fétis"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stories of Tonality in the Age of François-Joseph Fétis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Stories of Tonality in the Age of François-Joseph Fétis")]), _vm._v(" explores the concept of musical tonality through the writings of the Belgian musicologist François-Joseph Fétis (1784–1867), who was singularly responsible for theorizing and popularizing the term in the nineteenth century. Thomas Christensen weaves a rich story in which tonality emerges as a theoretical construct born of anxiety and alterity for Europeans during this time as they learned more about “other” musics and alternative tonal systems. Tonality became a central vortex in which French musicians thought—and argued—about a variety of musical repertoires, be they contemporary European musics of the stage, concert hall, or church, folk songs from the provinces, microtonal scale systems of Arabic and Indian music, or the medieval and Renaissance music whose notational traces were just beginning to be deciphered by scholars. Fétis’s influential writings offer insight into how tonality ingrained itself within nineteenth-century music discourse, and why it has continued to resonate with uncanny prescience throughout the musical upheavals of the twentieth and twenty-first centuries."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0